import { getLocalStorage as getStorage } from './storage';


export default function getUserShortName() {
  return getStorage(['shortName']).shortName;
}
